import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('library-files', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`library-files/${id}`).then(result => result.data)
  },
  // store(data) {
  //   return axios.post('playlists', data).then(result => result.data)
  // },
  update(id, data) {
    return axios.patch(`library-files/${id}`, data).then(result => result.data)
  },
  updateAttributes(fileIds, attributeValues) {
    return axios.post('library-files/sync-attributes', {
      files: fileIds,
      attribute_values: attributeValues
    }).then(result => result.data)
  },
  delete(ids) {
    return axios.post('library-files/delete', {
      library_file_ids: ids
    }).then(result => result.data)
  }
}
